import { type PropsWithChildren } from "react";

export const Body = ({ children }: Readonly<PropsWithChildren>) => (
  <div
    data-testid="circle-ai-shell-inset-body"
    className="flex min-h-0 flex-1 overflow-hidden"
  >
    {children}
  </div>
);

Body.displayName = "CircleAIAppShell.Layout.Inset.Body";
